"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectContainer = exports.CoreCharge = exports.AmountContainer = exports.AmountBlock = exports.PkgDescription = exports.PkgAmountBlock = exports.PkgAmount = exports.CrossButton = exports.TotalPrice = exports.TotalPriceBlock = exports.DisclaimerText = exports.DisclaimerTitle = exports.DisclaimerContainer = exports.NoAuth = exports.Warning = exports.PriceUnit = exports.Price = exports.PriceBlock = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const Typography_1 = __importDefault(require("../../../Components/UI/Typography"));
const Types_1 = require("Types");
exports.PriceBlock = styled_components_1.default.div `
  margin-bottom: ${props => props.variantType === Types_1.VariantTypes.PRODUCT_VIEW ? props.theme.spacing.s4 : props.theme.spacing.s2}px;

  ${props => props.variantType === Types_1.VariantTypes.PRODUCT_VIEW &&
    `
    display: flex;
    justify-content: space-between;
  `}

  ${props => props.variantType === Types_1.VariantTypes.CAROUSEL_VIEW &&
    `
    width: 100%;
    margin-top: ${props.theme.spacing.m3}px;
  `}

  ${props => props.centerAlign &&
    `
  display: flex;
  flex-direction: column;
  align-items: center;`}
`;
exports.Price = (0, styled_components_1.default)(Typography_1.default) `
  margin: 0;

  ${props => (props.variantType === Types_1.VariantTypes.CAROUSEL_VIEW || props.variantType === Types_1.VariantTypes.FULL_VIEW) &&
    `color: ${props.theme.palette.LIGHT_BLACK};`}
  ${props => props.variantType === Types_1.VariantTypes.MINI_CART_VIEW && `color: ${props.theme.palette.DARK_GRAY_100};`}

  ${props => props.variantType !== Types_1.VariantTypes.PRODUCT_VIEW &&
    `
    display: inline-block;
  `}
`;
exports.PriceUnit = (0, styled_components_1.default)(Typography_1.default) `
  margin: 0;
  text-transform: capitalize;
`;
exports.Warning = (0, styled_components_1.default)(Typography_1.default) `
  display: block;
  width: 100%;
  color: ${props => props.theme.palette.UI_WARNING};
  margin-top: ${props => props.theme.spacing.s4}px;
`;
exports.NoAuth = (0, styled_components_1.default)(Typography_1.default) `
  color: ${props => props.theme.palette.DARK_GRAY_80};

  ${props => props.variantType !== Types_1.VariantTypes.PRODUCT_VIEW &&
    `
    margin-bottom: ${props.theme.spacing.s4}px;
  `}
`;
exports.DisclaimerContainer = styled_components_1.default.div `
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${props => props.theme.palette.LIGHT_GRAY_20};
  padding: ${props => props.theme.spacing.s7}px ${props => props.theme.spacing.s4}px;
  margin-top: ${props => props.theme.spacing.s4}px;
  width: 100%;
`;
exports.DisclaimerTitle = (0, styled_components_1.default)(Typography_1.default) `
  margin-left: ${props => props.theme.spacing.s1}px;
  font-weight: ${props => props.theme.typography.weight.medium};
`;
exports.DisclaimerText = (0, styled_components_1.default)(Typography_1.default) `
  margin-left: ${props => props.theme.spacing.s4}px;
  font-size: ${props => props.theme.typography.size.s1}px;
  line-height: ${props => props.theme.typography.lineHeight.s3}px;
  overflow-wrap: anywhere;
`;
exports.TotalPriceBlock = styled_components_1.default.div `
  margin-top: ${props => props.theme.spacing.s4}px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
exports.TotalPrice = (0, styled_components_1.default)(Typography_1.default) `
  color: ${props => props.theme.palette.LIGHT_BLACK};
  user-select: none;
`;
exports.CrossButton = styled_components_1.default.button `
  cursor: pointer;
  border: none;
  background: none;
`;
exports.PkgAmount = (0, styled_components_1.default)(Typography_1.default) `
  ${props => (props.variantType === Types_1.VariantTypes.CAROUSEL_VIEW || props.variantType === Types_1.VariantTypes.FULL_VIEW) &&
    `color: ${props.theme.palette.LIGHT_BLACK};`}
  ${props => props.variantType === Types_1.VariantTypes.MINI_CART_VIEW && `color: ${props.theme.palette.DARK_GRAY_100};`}
  display: inline-block;
`;
exports.PkgAmountBlock = styled_components_1.default.div `
  display: flex;
  flex-direction: row;
  align-items: flex-end;

  margin-bottom: ${props => props.theme.spacing.s2}px;
  > h5 {
    margin-right: ${props => props.theme.spacing.s1}px;
  }
  > div {
    margin-left: ${props => props.theme.spacing.s1}px;
  }
`;
exports.PkgDescription = (0, styled_components_1.default)(Typography_1.default) `
  margin-bottom: ${props => props.theme.spacing.s2}px;
  color: ${props => props.theme.palette.DARK_GRAY_80};
`;
exports.AmountBlock = styled_components_1.default.div `
  display: flex;
  gap: ${props => props.theme.spacing.s2}px;

  ${props => props.variantType === Types_1.VariantTypes.MINI_CART_VIEW && `flex-direction: column;`}
  ${props => props.variantType === Types_1.VariantTypes.CAROUSEL_VIEW && `justify-content: space-between;`}
  ${props => (props === null || props === void 0 ? void 0 : props.isOrderPrint) && `flex-direction: column;`}

  @media (max-width: ${props => props.theme.breakpoints.xxl}px) {
    flex-direction: column;
  }

  > div {
    ${props => (props === null || props === void 0 ? void 0 : props.isOrderPrint) &&
    `max-width: none;
       width: 100%;
       margin-bottom: ${props.theme.spacing.s4}px;
    `}

    @media (max-width: ${props => props.theme.breakpoints.xxl}px) {
      max-width: ${props => props.theme.constants.blockWidth.xl}px;
    }

    @media (max-width: ${props => props.theme.breakpoints.md}px) {
      ${props => props.variantType === Types_1.VariantTypes.FULL_VIEW &&
    !props.isOrderPrint &&
    `max-width: none;
      width: 50%;`}
    }
  }

  > button {
    white-space: nowrap;
    padding: ${props => props.theme.spacing.s3}px ${props => props.theme.spacing.m1}px;

    ${props => (props === null || props === void 0 ? void 0 : props.isOrderPrint) &&
    `margin-left: 0;
    width: 100%;`}

    @media (max-width: ${props => props.theme.breakpoints.md}px) {
      ${props => props.variantType === Types_1.VariantTypes.FULL_VIEW &&
    !props.isOrderPrint &&
    `
      width: 50%;
    `}
    }
  }
`;
exports.AmountContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
exports.CoreCharge = (0, styled_components_1.default)(Typography_1.default) `
  margin-bottom: ${props => props.theme.spacing.s2}px;
`;
exports.SelectContainer = styled_components_1.default.div `
  align-self: flex-end;

  > div {
    margin: 0;
  }

  @media (max-width: ${props => props.theme.breakpoints.md}px) {
    ${props => (props === null || props === void 0 ? void 0 : props.variantType) === Types_1.VariantTypes.FULL_VIEW && `width: 50%; > div { width: 100%; }`}
  }
`;
exports.default = {
    PriceBlock: exports.PriceBlock,
    Price: exports.Price
};
